import React, { useEffect } from 'react';

import HeaderMeta from 'components/headerMeta/HeaderMeta';
import { charterEmail } from 'untils/constant/email';
import { buildOrganizationSchema, buildPageBreadcrumb } from 'untils/jsonLdSchemas';
import '../../assets/style/itemStyle/common.scss';
import Footer from '../../components/layout/Footer';
import HubspotForm from './components/HubspotForm';
import Map from './components/Map';
const ContactUs = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <HeaderMeta
        type="contactUs"
        jsonLd={[buildOrganizationSchema(), buildPageBreadcrumb('Contact Us', '/contactUs')]}
      />
      <div className="contact-us-container">
        <div className="banner">
          <img
            src={require('../../assets/imgs/webp/contact-us-banner.webp').default}
            alt="contact us banner"
          />
          <h1 className="banner-title">Contact Us</h1>
        </div>
        <div className="contact-us-content">
          <h3>Ask Us Anything!</h3>
          <HubspotForm
            scriptSrc="https://js.hsforms.net/forms/v2.js"
            formId="832533e3-946f-43a3-8bad-2e7762e918bb"
          />
          <div className="info-bottom">
            <ul>
              <li>Airacer Inc.</li>
              <li>
                <p>
                  28-07 Jackson Ave,
                  <br />
                  Long Island City, NY 11101
                </p>
              </li>
              <li>
                <p>
                  Email:
                  <br />
                  {charterEmail}
                </p>
                <p>
                  Tel:
                  <br />
                  +1 800-213-5051
                </p>
              </li>
            </ul>
            <Map />
          </div>
        </div>
        <img
          src={require('../../assets/imgs/webp/contact-popup.webp').default}
          alt="contact popup"
          style={{ display: 'none' }}
        />
      </div>
      <Footer />
    </>
  );
};

export default ContactUs;
